export default __webpack_public_path__ + "static/media/github.1e61d3b3.png";